<template>
  <div
    class="video-box"
    ref="videoBox"
    :style="{ 'z-index': isPlaying ? 1 : -1 }"
  ></div>
</template>

<script>
import VoiceRoomEventEmitter from '@/components/VoiceRoom/voiceRoomEventBus';
import VoiceRoomEvent from '@/components/VoiceRoom/voiceRoomEvent';
import VoiceRoomVideoProvider from '@/components/VoiceRoom/videoProvider';
import Vap from 'video-animation-player';
import { getVapConfig } from '@/components/VoiceRoom/vapc-mp4-helper';

export default {
  name: 'voiceRoomVideo',
  data() {
    return {
      videoSrc: '',
      isPlaying: false,
      vap: null
    };
  },
  created() {
    VoiceRoomEventEmitter.on(VoiceRoomEvent.playVideo, async src => {
      await this.init(src);
    });
  },
  methods: {
    async init(src) {
      try {
        if (this.vap) {
          this.vap.destroy();
          this.vap = null;
        }
        const config = await getVapConfig(src);
        let width = this.$refs.videoBox ? this.$refs.videoBox.offsetWidth : 520;
        let height = this.$refs.videoBox
          ? this.$refs.videoBox.offsetHeight
          : 844;
        const showHeight = (width * config.info.h) / config.info.w;
        // if (height - showHeight > 0) {
        //   height = showHeight;
        // } else {
        //   width =
        //     (height * config.info.w) / config.info.h;
        // }
        if (height - showHeight > 0) {
          width = height * config.info.w / config.info.h;
        } else {
          height = showHeight;
        }
        console.log(width,height,this.$refs.videoBox.offsetWidth,this.$refs.videoBox.offsetHeight,config.info.w,config.info.h);
        this.vap = new Vap({
          container: this.$refs.videoBox,
          src: src,
          config: config,
          width: width,
          height: height,

          precache: true,
          accurate: true,
          mute: true,
          type: 'src'
        });
        this.vap.on('ended', () => {
          this.onVideoEnded();
        });
        this.playVideo();
      } catch (error) {
        console.log(error);
        this.onVideoEnded();
      }
    },
    playVideo() {
      this.vap.setTime(0);
      this.isPlaying = true;
      this.vap.play(); // 播放视频
    },
    onVideoEnded() {
      VoiceRoomVideoProvider.playEnd();
      if (this.vap) {
        this.vap.destroy();
        this.vap = null;
      }
      this.isPlaying = VoiceRoomVideoProvider.play();
    }
  }
};
</script>
<style lang="scss" scoped>
video {
  width: 100%;
  height: 100%;
}
</style>
<style lang="scss">
.video-box {
  pointer-events: none;
  canvas {
    pointer-events: none;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
